import React from "react";
import {
  Input,
  Select,
  message,
  Checkbox,
  DatePicker,
  InputNumber,
  Button,
} from "antd";
import moment from "moment";
import { MinusCircleOutlined } from "@ant-design/icons";
import ReminderTableElm from "./ReminderTable";

const TYPE = "CONTRACT_STORAGE_REMINDER";
const ErrorMessageSameDate =
  "Reminder Date Should Be Before The Expiration Date";
const ErrorMessageBeforeDate =
  "Reminder Date Should Be After The Effective(Current) Date";

const NotificationSchedulesShowElement = (props) => {
  const {
    Form,
    control,
    errors,
    Controller,
    fields,
    remove,
    append,
    setValue,
    isExpDateChange,
    setExpDateChange,
    setISMyDocsTrigger,
    watch,
  } = props;

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < moment().endOf("day");
  };

  const addSchedules = () => {
    const AppExpirationDate = fields.map((x) => x.expirationDate);

    const PrimaryRecipientData = watch(
      `notificationSchedules.schedules.[0].primaryRecipient`,
    );
    const SecondaryRecipientData = watch(
      `notificationSchedules.schedules.[0].secondaryRecipient`,
    );
    const dataElement = [
      {
        type: TYPE,
        expirationDate: AppExpirationDate[0],
        reminderDays: 1,
        scheduleSet: false,
        reminderDate: moment
          .utc(AppExpirationDate[0], "MM-DD-YYYY")
          .subtract(1, "days")
          .local()
          .format("MM-DD-YYYY"),
        primaryRecipient: PrimaryRecipientData,
        secondaryRecipient:
          Array(SecondaryRecipientData).length > 0
            ? SecondaryRecipientData
            : "",
      },
    ];
    append(dataElement);
  };

  // ExpirationDate - when expiration Date is today  date
  const onChangeExpirationDate = (date, dateString, index) => {
    if (dateString !== null) {
      const expiryDateNew = moment
        .utc(dateString, "MM-DD-YYYY")
        .format("MM-DD-YYYY");

      for (let index = 0; index < fields?.length; index++) {
        setValue(
          `notificationSchedules.schedules.${index}.expirationDate`,
          expiryDateNew,
        );

        const reminderDateNew = moment
          .utc(expiryDateNew, "MM-DD-YYYY")
          .subtract(fields[index].reminderDays, "days")
          .local()
          .format("MM-DD-YYYY");

        setValue(
          `notificationSchedules.schedules.${index}.reminderDate`,
          reminderDateNew,
        );

        fields[index].expirationDate = expiryDateNew;
        fields[index].reminderDate = reminderDateNew;
      }

      setExpDateChange(false);
      setISMyDocsTrigger(true);
    }
  };
  // reminderDays
  const onChangeReminderDays = (e, index) => {
    const date = moment
      .utc(fields[index].expirationDate, "MM-DD-YYYY")
      .subtract(e, "days")
      .local()
      .format("MM-DD-YYYY");

    if (
      moment(fields[index].expirationDate, "MM-DD-YYYY").isSame(
        moment(date, "MM-DD-YYYY"),
      )
    ) {
      message.error(ErrorMessageSameDate);
    } else if (
      moment(date, "MM-DD-YYYY").isBefore(moment(new Date(), "MM-DD-YYYY"))
    ) {
      message.error(ErrorMessageBeforeDate);
    } else {
      setValue(`notificationSchedules.schedules.${index}.reminderDate`, date);
      fields[index].reminderDays = e;
      fields[index].reminderDate = date;
    }
  };

  const columns = [
    {
      title: "Expiration Date",
      dataIndex: "expirationDate",
      key: "expirationDate",
      responsive: ["lg"],
      render: (_, record, index) => (
        <Form.Item
          valuePropName="date"
          help={
            errors?.notificationSchedules?.schedules?.[index]?.expirationDate
              ?.message
          }
          required
          validateStatus={
            errors?.notificationSchedules?.schedules?.[index]?.expirationDate
              ? "error"
              : ""
          }
        >
          <Controller
            control={control}
            name={`notificationSchedules.schedules.${index}.expirationDate`}
            render={({ field: { onChange, value } }) => (
              <DatePicker
                disabled={isExpDateChange === false}
                value={moment(value, "MM-DD-YYYY")}
                disabledDate={disabledDate}
                style={{ width: 120 }}
                format="MM-DD-YYYY"
                onChange={(date, dateString) => {
                  onChange(date, dateString);
                  onChangeExpirationDate(
                    date,
                    dateString,
                    index,
                    "expirationDate",
                  );
                }}
              />
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Reminder (days)",
      dataIndex: "reminderDays",
      key: "reminderDays",
      responsive: ["lg"],
      render: (_, record, index) => (
        <Form.Item
          help={
            errors?.notificationSchedules?.schedules?.[index]?.reminderDays
              ?.message
          }
          required
          validateStatus={
            errors?.notificationSchedules?.schedules?.[index]?.reminderDays
              ? "error"
              : ""
          }
        >
          <Controller
            control={control}
            name={`notificationSchedules.schedules.${index}.reminderDays`}
            render={({ field: { onChange, value } }) => (
              <InputNumber
                disabled={isExpDateChange === true}
                style={{ width: 100 }}
                min={0}
                value={value}
                onChange={(e) => {
                  onChange(e);
                  onChangeReminderDays(e, index, "reminderDays");
                }}
              />
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Reminder Date",
      dataIndex: "reminderDate",
      key: "reminderDate",
      responsive: ["lg"],
      render: (_, record, index) => (
        <Form.Item
          help={
            errors?.notificationSchedules?.schedules?.[index]?.reminderDate
              ?.message
          }
          required
          validateStatus={
            errors?.notificationSchedules?.schedules?.[index]?.reminderDate
              ? "error"
              : ""
          }
        >
          <Controller
            control={control}
            name={`notificationSchedules.schedules.${index}.reminderDate`}
            render={({ field: { value } }) => (
              <DatePicker
                value={moment(value, "MM-DD-YYYY")}
                disabledDate={disabledDate}
                style={{ width: 120 }}
                format="MM-DD-YYYY"
                disabled
              />
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Status",
      dataIndex: "scheduleSet",
      key: "scheduleSet",
      width: "80px",
      responsive: ["md"],
      render: (_, record, index) => (
        <Form.Item
          help={
            errors?.notificationSchedules?.schedules?.[index]?.scheduleSet
              ?.message
          }
          required
          validateStatus={
            errors?.notificationSchedules?.schedules?.[index]?.scheduleSet
              ? "error"
              : ""
          }
        >
          <Controller
            control={control}
            name={`notificationSchedules.schedules.${index}.scheduleSet`}
            render={({ field: { onChange, value } }) => (
              <Checkbox
                style={{ marginLeft: 10 }}
                checked={value}
                onChange={(e) => {
                  onChange(e);
                }}
              />
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Primary Alert Recipient",
      dataIndex: "primaryRecipient",
      key: "primaryRecipient",
      responsive: ["lg"],
      render: (_, record, index) => (
        <Form.Item
          help={
            errors?.notificationSchedules?.schedules?.[index]?.primaryRecipient
              ?.message
          }
          required
          validateStatus={
            errors?.notificationSchedules?.schedules?.[index]?.primaryRecipient
              ? "error"
              : ""
          }
        >
          <Controller
            control={control}
            name={`notificationSchedules.schedules.${index}.primaryRecipient`}
            render={({ field: { onChange, value } }) => (
              <Input
                placeholder="Primary Recipient"
                onChange={(e) => {
                  onChange(e);
                }}
                value={Array(value).length === 0 ? undefined : value}
              />
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: " Additional Alert Recipient(s)",
      dataIndex: "secondaryRecipient",
      key: "secondaryRecipient",
      responsive: ["lg"],
      render: (_, record, index) => (
        <Form.Item
          help={
            errors?.notificationSchedules?.schedules?.[index]
              ?.secondaryRecipient?.message
          }
          validateStatus={
            errors?.notificationSchedules?.schedules?.[index]
              ?.secondaryRecipient
              ? "error"
              : ""
          }
        >
          <Controller
            control={control}
            name={`notificationSchedules.schedules.${index}.secondaryRecipient`}
            render={({ field: { onChange, value } }) => (
              <Select
                mode="tags"
                placeholder="Secondary Recipient"
                onChange={(e) => {
                  onChange(e);
                }}
                value={Array(value).length === 0 ? undefined : value}
              />
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Operation",
      dataIndex: "operation",
      width: "80px",
      align: "center",
      render: (_text, _record, index) => (
        <Button
          className="dynamic-delete-button"
          onClick={() => {
            remove(index);
          }}
          style={{
            margin: "0 8px",
            border: "none",
            backgroundColor: "transparent",
            outline: "none",
          }}
          icon={<MinusCircleOutlined />}
          disabled={fields?.length === 1}
        />
      ),
    },
  ];

  return (
    <ReminderTableElm
      columns={columns}
      schedules={fields}
      addSchedules={addSchedules}
      disabled={
        fields?.length === 0 ||
        Object.keys(errors).length !== 0 ||
        isExpDateChange === true
      }
    />
  );
};

export default NotificationSchedulesShowElement;
